import { defineRecipe } from '@chakra-ui/react'

// Rendered by <PageContainer> in src/components/layout/PageContainer.tsx. It sits
// inside the application shell and limits the content column, while the shell's
// header spans the full viewport width.
export const pageContainerRecipe = defineRecipe({
  className: 'page-container',
  base: {
    width: 'full',
    maxWidth: 'pageContent',
    marginInline: 'auto',
    paddingInline: { base: '4', md: '6' },
    paddingBlock: { base: '8', md: '12' },
    minWidth: '0',
  },
  variants: {
    variant: {
      // An ordinary page: Page.Root provides the rhythm inside.
      default: {},
      // The dashboard has no page header, so the container stacks the widgets
      // itself.
      dashboard: {
        display: 'flex',
        flexDirection: 'column',
        // Same rhythm as Page.Content, so the dashboard and subpages space their
        // blocks identically.
        gap: 'page',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
